const { REACT_APP_API_BASE_URL } = process.env;

export const loginUser = (email, password) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/users/login/business', {
    method: 'POST',
    body: JSON.stringify({ data: { email, password } }),
    headers: {
      'Content-Type': 'application/json'
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const logoutUser = token => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/users/logout', {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const getProfile = token => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/users/me', {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const updateProfile = (token, user) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/users/me', {
    method: 'PUT',
    body: JSON.stringify({ user }),
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});